class ConfiguracaoGrupoController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'configuracaoGrupoService', 'atividadeService', 'segmentoService']

  constructor: ($injector, @pathService, @configuracaoGrupoService, @atividadeService, @segmentoService)->
    super($injector)
    @loadingTracker = @promiseTracker()

    url = @pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/pis-cofins/configuracao-grupo/'
    @modalConfiguracaoGrupo = @openPopup(url + 'modal.html', 'configuracaoGrupoModalController as ctrl', 'md')

    @lists = {}

    @loadInitial()

  loadInitial: ->
    @loadDefault()
    
    @loadingTracker.addPromise @segmentoService.getList((data) =>
      @lists.listOfGrupo = data
    )

    @loadingTracker.addPromise @atividadeService.getList((data) =>
      @lists.listOfAtividade = data
    )

  loadDefault: ->
    @loadingTracker.addPromise @configuracaoGrupoService.getList((data)=>
      @listOfConfiguracaoGrupo = data
    )

  adicionar: () ->
    @modalConfiguracaoGrupo({
        configuracaoGrupo: -> {}
        lists: => @lists
      }, (result) => @loadDefault()
    )

  editar: (configuracaoGrupo) ->
      @modalConfiguracaoGrupo({
          configuracaoGrupo: => angular.copy configuracaoGrupo
          lists: => @lists
        },
        (result) => @loadDefault()
      )

  remover: (configuracaoGrupo)->
    @Confirm.warning("Atenção",
      """
Deseja realmente apagar a configuração de PIS/COFINS para a atividade <strong>#{configuracaoGrupo.atividade.nome}</strong>
e grupo <strong>#{configuracaoGrupo.grupo.codigo} - #{configuracaoGrupo.grupo.nome}</strong>?
""",
      {
        "Sim": =>
          @configuracaoGrupoService.delete(configuracaoGrupo.id, (data)=>
            if(data.success)
              @Alert.success("Configuração removida com sucesso.")
              @loadDefault()
          )
        "Não": null
      })

angular.module("eficienciaFiscalModule").controller("configuracaoGrupoController", ConfiguracaoGrupoController)

class ConfiguracaoGrupoModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'configuracaoGrupoService', 'configuracaoGrupo', 'lists' ]

  constructor: ($injector, @modalInstance, @configuracaoGrupoService, @configuracaoGrupo, lists)->
    super($injector)

    @submitTracker = @promiseTracker()

    @listOfGrupo = lists.listOfGrupo
    @listOfAtividade = lists.listOfAtividade

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @configuracaoGrupoService.save(angular.copy(data), (result) =>
          @Alert.success("Configuração #{if data.id then 'atualizada' else 'adicionada'} com sucesso.",
            'Sucesso')
          @modalInstance.close()
        )
      )

angular.module("eficienciaFiscalModule").controller("configuracaoGrupoModalController", ConfiguracaoGrupoModalController)